import http from "@/api/client";

export async function getAppState() {
  const { data } = await http.get("/app/state");
  return data;
}
